import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './reducers'
import { undoRedoMiddleware } from './middleware/undoRedoMiddleware'

const initializeStore = (
  preloadedState = {
    entities: {
      app: { name: `didn't get preloaded state` },
    },
  }
) => {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({ immutableCheck: false }).concat(
        undoRedoMiddleware
      ),
  })
  return store
}

export const asyncInitializeStore = async req => {
  const data = await req
  return initializeStore(data)
}

export default initializeStore
